import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { HOME_ROUTE } from '@/config';
import { LoginHeader } from '@/components/Header';
import { ApiCacheProvider } from '@/pages/ApiCache.context';
import { AppProvider } from '@/pages/App.context';
import styles from './AuthLayout.module.scss';

const AuthLayout = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const pathname = window.location.pathname;
  // The password-recovery routes must stay reachable while another account is
  // signed in here, otherwise a logged-in user can never request or complete a
  // reset (e.g. for a second account) — they just get bounced to the dashboard.
  // `/auth/reset-password` additionally clears the stale session on arrival so
  // the reset runs against its URL token; `/auth/forgotten-password` only sends
  // an email (no token), so its session is left intact.
  const shouldRedirect =
    !!token &&
    !pathname.includes('/auth/register') &&
    !pathname.includes('/auth/invite') &&
    !pathname.includes('/auth/forgotten-password') &&
    !pathname.includes('/auth/reset-password');

  useEffect(() => {
    if (shouldRedirect) {
      void navigate(HOME_ROUTE);
    }
  }, [shouldRedirect, navigate]);

  if (shouldRedirect) {
    return null;
  }

  /*
   * Please do not add any Suspense here as this feels somehow broken!
   * */
  return (
    <ApiCacheProvider token={token}>
      <AppProvider>
        <main className={styles.main}>
          <LoginHeader />
          <section className={styles.content}>
            <Outlet />
          </section>
        </main>
      </AppProvider>
    </ApiCacheProvider>
  );
};

export default AuthLayout;
